import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';

// Nobody gets a reset email: whoever forgot their password asks at a centre,
// and staff generate a link here to hand over in person or by message.

export type ResetLinkKind = 'participant' | 'guardian' | 'staff';

export interface ResetLink {
  url: string;
  /** The same link as a PNG data URL, to scan off the screen. */
  qrCode: string;
  /** ISO timestamp; the link stops working after it. */
  expiresAt: string;
}

const PATH: Record<ResetLinkKind, string> = {
  participant: '/api/participants',
  guardian: '/api/guardians',
  staff: '/api/users',
};

/** POST /api/{participants|guardians|users}/{id}/reset-link. Replaces any earlier link. */
export function useResetLink() {
  return useMutation({
    mutationFn: ({ kind, id }: { kind: ResetLinkKind; id: number }) =>
      api.post<ResetLink>(`${PATH[kind]}/${id}/reset-link`),
  });
}
